import * as React from "react";
import { CommonConstants } from "../common/constants/common-constants";
import { IAPIResponse, IHTTPResponse } from "../common/models/httpModels";
import { HTTPService } from "../common/services/httpService";
import { IForgotPasswordModel } from "./forgotPasswordModels";

const httpService = new HTTPService();
const submit = (request: IForgotPasswordModel): Promise<IHTTPResponse<IAPIResponse<any>>> => {
  const url = `${CommonConstants.BaseAddress}${
    CommonConstants.ApiConstants.ForgotPassword
  }`;
  return httpService.post(url,request);
};

const ForgotPasswordService = {
    submit,
};

export default ForgotPasswordService;
